import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ScrollText, Waves, Users } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Container, SectionHeading } from "@/components/shared";

const chapters = [
  {
    to: "/story/1630",
    icon: <ScrollText size={20} />,
    kicker: "Cornerstone",
    title: "The renaming of 1630",
    body: "John Cotton, the Winthrop fleet, and the day the name crossed the ocean — with an honest word about the land and its keepers.",
  },
  {
    to: "/lincolnshire",
    icon: <Waves size={20} />,
    kicker: "The mother town",
    title: "Boston, Lincolnshire",
    body: "A wool port turned market town, steering by the Stump on the edge of the Wash.",
  },
  {
    to: "/massachusetts",
    icon: <Users size={20} />,
    kicker: "The daughter city",
    title: "Boston, Massachusetts",
    body: "From Shawmut and Trimountaine to a great Atlantic harbour that kept the old name.",
  },
];

export default function Story() {
  return (
    <div>
      <PageHero
        kicker="The story"
        title="One name, carried across an ocean"
        intro="How a Lincolnshire market town lent its name to a city in the New World — and why a private citizen keeps the crossing open, four hundred years on."
      />
      <section className="py-16 sm:py-24">
        <Container>
          <SectionHeading kicker="Read in order" title="Chapters of the crossing" className="mb-10" />
          <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
            {chapters.map((c) => (
              <Link
                key={c.to}
                to={c.to}
                data-testid={`story-chapter-${c.to.replace(/\//g, "-")}`}
                className="group bg-[#FFFAF3] border border-[#D6D3CB] p-8 hover:border-[#CDA434] transition-colors flex flex-col"
              >
                <div className="w-11 h-11 border border-[#CDA434] flex items-center justify-center text-[#CDA434] mb-5">
                  {c.icon}
                </div>
                <span className="font-sans text-xs uppercase tracking-[0.2em] text-[#505A68] mb-2">{c.kicker}</span>
                <h3 className="font-serif text-xl text-[#1E1E2F] group-hover:text-[#003366] transition-colors">{c.title}</h3>
                <p className="font-sans text-sm text-[#505A68] leading-relaxed mt-3 flex-1">{c.body}</p>
                <span className="mt-5 inline-flex items-center gap-1 font-sans text-sm font-semibold text-[#003366]">
                  Read <ArrowRight size={15} />
                </span>
              </Link>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
